import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BuilderSetupBillingInvoicesRedirectRoutingModule } from './builder-setup-billing-invoices-redirect-routing.module';
import { BillingInvoicesRedirectComponent } from './billing-invoices-redirect.component';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    BuilderSetupBillingInvoicesRedirectRoutingModule,
  ],
  declarations: [
    BillingInvoicesRedirectComponent,
  ],
  providers: [
  ],
})
export class BuilderSetupBillingInvoicesRedirectModule {
}


